export default __webpack_public_path__ + "static/media/payments.8e450dc8.jpg";